import { createContext, useContext } from "react";

import { DocumentGroup } from "@/api";

import { PendingDocumentMove } from "./DropZoneDnd.types";

export interface PendingMoveZoneHandlers {
  addMove: (move: PendingDocumentMove) => void;
  removeMove: (documentId: string) => void;
}

interface PendingDocumentMovesContextValue {
  /** Mirror of the mounted asset inventory view's pending form moves. */
  pendingMoves: PendingDocumentMove[];
  /** Cancels one pending move via the owning view's form. Safe no-op if no view is registered. */
  removePendingMove: (move: PendingDocumentMove) => void;
  /** Registers the mounted view's handlers for its asset zone; returns an unregister function. */
  registerAssetZone: (zone: DocumentGroup, handlers: PendingMoveZoneHandlers) => () => void;
  /** Publishes the mounted view's current pending moves into the mirror. */
  publishPendingMoves: (moves: PendingDocumentMove[]) => void;
}

const defaultValue: PendingDocumentMovesContextValue = {
  pendingMoves: [],
  removePendingMove: () => undefined,
  registerAssetZone: () => () => undefined,
  publishPendingMoves: () => undefined,
};

export const PendingDocumentMovesContext = createContext(defaultValue);
export const usePendingDocumentMovesContext = (): PendingDocumentMovesContextValue =>
  useContext(PendingDocumentMovesContext);
